import Container from './trips-container';

export default Container;
